import * as Yup from 'yup';

const schema = Yup.object().shape({
    newPassword: Yup.string().required('O campo deve ser preenchido'),//.min(6, 'A senha deve ter no mínimo 6 caracteres'),
    confirmNewPassword: Yup.string().required('O campo deve ser preenchido').test('password-match', 'As senhas não são iguais', function (value) { return this.parent.newPassword == value; }),
});

export default schema;